module.exports = function(itemId, amount = 1) {
    this._sendMessage('amountForItem', {
        itemId: itemId,
        amount: {type: 'subtract', value: amount}
    })
};